module.exports = __webpack_public_path__ + "img/weather68.b221ac1f.png";